import { formatPrice } from "PosterEditor/utils/format-price";
import { PosterProject } from "PosterEditor/model/poster-project";
import { useSizePresets } from "PosterEditor/model/size-presets/size-preset";

export const useCheckoutPricing = () => {
  const { sizePresetFromProject, sizePresets } = useSizePresets();

  const priceValueForProject = (project: PosterProject): number => {
    const preset = sizePresetFromProject(project);
    return preset?.priceInt ?? 0;
  };

  const formattedPriceForProject = (project?: PosterProject) => {
    if (project) {
      const price = priceValueForProject(project);
      return formatPrice(price);
    }
    // Return first available price as default for marketing pages
    const defaultPrice = sizePresets?.[0]?.priceInt ?? 299;
    return formatPrice(defaultPrice);
  };

  const formattedPriceForProjects = (projects: PosterProject[]) => {
    const totalPrice = projects.reduce((sum, project) => {
      return sum + priceValueForProject(project);
    }, 0);
    return formatPrice(totalPrice);
  };

  const stripePriceIDForProject = () => {
    const id =
      process.env.REACT_APP_STRIPE_PRICE_ID ?? "price_1RvH09KNeNkzuQYhdjxpzWW3";
    return id;
  };

  return {
    priceValueForProject,
    formattedPriceForProject,
    formattedPriceForProjects,
    stripePriceIDForProject,
  };
};
